var AbstractView = require("./AbstractView");

/**
 * Base class for all dialogs.
 *
 * Provides basic container and header.
 * @class
 */
var AbstractDialog = function() {
    var $content = $(require("html!./dialog_template.html"));
    var $title = $content.find(".dialogTitle");
    var anchor;

    $content.find("a").on("click", function() {
        $content.popup("close");
    });

    /**
     * Returns the jQuery-wrapped element for the dialog
     *
     * @returns {jQuery}
     */
    this.getContent = function() {
        return $content;
    };

    /**
     * Set the element selector to which the dialog should be anchored
     *
     * @param {string} selector
     */
    this.setAnchor = function(selector) {
        anchor = selector;
    };

    this.getAnchor = function() {
        return anchor;
    };

    /**
     * Sets the text shown in the title area of the dialog
     *
     * @param {string} title
     */
    this.setTitle = function(title) {
        $title.text(title);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "dialog";
    };

    this.show = function() {
        // Nothing to do -- display is handled by parent view container
    };

    this.hide = function() {
        // Nothing to do -- display is handled by parent view container
    };

    this.resize = function(width, height) {
        // TODO
    };
};

AbstractDialog.prototype = AbstractView;

module.exports = AbstractDialog;